import e from "react";
import { Professional as s } from "../Professional/index.js";
import { OnlineStatus as r } from "../OnlineStatus/index.js";
const i = _ref => {
  let {
    isProfessionalAd: l,
    isOnline: t,
    fixedHeightElements: a
  } = _ref;
  return !l && !t && a ? e.createElement("span", {
    className: "olx-ad-card__seller-details--fixed"
  }) : !l && !t ? null : e.createElement("div", {
    className: "olx-ad-card__seller-details"
  }, e.createElement(s, null, l), e.createElement(r, null, t));
};
export { i as SellerDetails };